import store from '@/store'

export const provideSchool = () => {
    return store.state.school
}
